module.exports = __webpack_public_path__ + "static/media/checked.1fe161ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/checked.svg
// module id = 135
// module chunks = 0